<template>
  <div>
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'" class="form-header">
              Editar{{ '' }} {{ oldName }}
            </h5>


            <h5 v-else class="form-header">Adicionar {{ '' }}</h5>
          </div>
          <div class="col-xs-12 pl-3 pr-3">
            <b-form-text id="nameInput">Nome *</b-form-text>
            <b-form-input
              v-model.trim="form.NAME"
              placeholder="Informe o nome"
              maxlength="24"
              size="sm"

              aria-describedby="nameInput nameInputLiveFeedback"
              id="nameInput"
              :state="nameState && notRepeatedName"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>

            <b-form-text id="transmissibilityInput">Transmissividade do solo *</b-form-text>
            <!-- <b-form-input
              v-model="form.TRANSMISSIVITY"
              placeholder="Informe a transmissividade"
              maxlength="24"
              size="sm"
              type="number"
              :formatter="notEmpty"
              aria-describedby="transmissibilityInput transmissibilityInputLiveFeedback"
              id="transmissibilityInput"
              :state="transmissibilityState.isValid"
            >
            </b-form-input> -->
            <b-form-select
                v-model="form.TRANSMISSIVITY"
                :options="transmissivityOptions"
                text-field="NAME"
                value-field="VALUE"
                size="sm"
                aria-describedby="modelSelectLiveFeedback"
                required
                :state="transmissibilityState.isValid"
                >

                <template slot="first">
                  <option :value="''" disabled>
                    Selecione o fator de transmissividade *
                  </option>
                </template>
              </b-form-select>

            <b-form-invalid-feedback
              v-if="!transmissibilityState.isValid"
              id="transmissibilityInputLiveFeedback"
            >
              Obrigatório e {{transmissibilityState.message}}
            </b-form-invalid-feedback>

            <b-form-text id="fieldCapacityInput">Capacidade de Campo (%) *</b-form-text>
            <b-form-input
              v-model="form.FIELD_CAPACITY"
              placeholder="Informe a capacidade de campo"
              maxlength="24"
              size="sm"
              type="number"
              :formatter="notEmpty"
              aria-describedby="fieldCapacityInput fieldCapacityInputLiveFeedback"
              id="fieldCapacityInput"
              :state="fieldCapacityInputState.isValid"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!fieldCapacityInputState.isValid"
              id="fieldCapacityInputLiveFeedback"
            >
              Obrigatório e {{fieldCapacityInputState.message}}
            </b-form-invalid-feedback>

            <b-form-text id="wiltPointInput">Ponto de Murcha Permanente (%) *</b-form-text>
            <b-form-input
              v-model="form.WILT_POINT"
              placeholder="Informe o ponto de murcha"
              maxlength="24"
              size="sm"
              type="number"
              :formatter="notEmpty"
              aria-describedby="wiltPointInput wiltPointInputLiveFeedback"
              id="wiltPointInput"
              :state="wiltPointInputState.isValid"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!wiltPointInputState.isValid"
              id="wiltPointInputLiveFeedback"
            >
              Campo obrigatório e {{wiltPointInputState.message}}
            </b-form-invalid-feedback>

            <b-form-text id="densityInput">Densidade Aparente (g/cm³) *</b-form-text>
            <b-form-input
              v-model="form.DENSITY"
              placeholder="Informe a densidade aparante"
              maxlength="24"
              size="sm"
              type="number"
              :formatter="notEmpty"
              aria-describedby="densityInput densityInputLiveFeedback"
              id="densityInput"
              :state="densityInputState.isValid"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!densityInputState.isValid"
              id="densityInputLiveFeedback"
            >
              Obrigatório e {{densityInputState.message}}
            </b-form-invalid-feedback>
          </div>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2 d-flex">
        <b-btn size="sm" variant="outline-secondary" @click="$emit('close-form')" class="ml-2 mr-1 w-100"> Cancelar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2 w-100"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import validate from "@/pages/components/regist/form-functions";
import { soilUseCase } from "@/api/modules/soil/useCases";
import {cookies} from "../../../components/cookies";
import managementSectorsActions from "@/mixins/managementSectorActions.js";

export default {
  name: "soil-form",
  mixins: [managementSectorsActions],
  props: {
    items: {
      required: false,
      default: () => []
    },
    formType: String,
    itemToEdit: [Number, Object],
    // oldName: [Boolean, Number, String],
    // alreadyUsedNames:  [Array,Number],
  },
  data() {
    return {
      errors: [],
      form: {
        NAME:'',
        TRANSMISSIVITY:'',
        FIELD_CAPACITY:'',
        WILT_POINT:'',
        DENSITY:'',
        FK_EDITOR:null
      },
      transmissivityOptions:[
        {VALUE:0.87,NAME:"Muito arenoso (0.87)"},
        {VALUE:0.90,NAME:"Arenoso (0.90)"},
        {VALUE:0.95,NAME:"Intermediário (0.95)"},
        {VALUE:1.00,NAME:"Argiloso (1.00)"},
      ]
    };
  },
  computed: {
    notRepeatedName() {
      const currentName = this.form.NAME || '';
      const alreadyUsedNames = this.items.filter(val => val.ID !== this.idSoil)
        .map(val => val.NAME);

      return currentName.length && !alreadyUsedNames.find(name => name === currentName);
    },
    oldName() {
      return this.itemToEdit && this.itemToEdit.NAME;
    },
    idSoil() {
      return this.itemToEdit ? this.itemToEdit.ID : null;
    },
    nameState() {
      return !!this.form.NAME;
    },
    transmissibilityState(){
      return validate.againstZeroInput(this.form.TRANSMISSIVITY)
    },
    densityInputState(){
      return validate.againstZeroInput(this.form.DENSITY)
    },
    fieldCapacityInputState(){
      return validate.isPercentageInput(this.form.FIELD_CAPACITY)
    },
    wiltPointInputState(){
      const fieldCapacity = Number(this.form.FIELD_CAPACITY)
      const wiltPoint = Number(this.form.WILT_POINT)

      const isPercentageFieldCapacity= validate.checkIfInputIsPercentage(fieldCapacity)
      const isPercentageWiltPoint= validate.checkIfInputIsPercentage(wiltPoint)

      if(!isPercentageWiltPoint){
        return validate.invalid('é permitido apenas números entre 1 e 100')
      }
      if(isPercentageFieldCapacity){
        const isGreaterOrEqual=validate.checkIfGreaterOrEqual(wiltPoint,fieldCapacity)
        if(isGreaterOrEqual){
          return validate.invalid('não deve ser maior ou igual a capacidade de campo')
        }
      }
      return validate.ok()
    }
  },
  created() {
    if (this.formType == "add") this.resetForm();
    else {
      this.form.ID = this.itemToEdit.ID;
      this.form.NAME = this.itemToEdit.NAME;
      this.form.TRANSMISSIVITY = this.itemToEdit.TRANSMISSIVITY;
      this.form.FIELD_CAPACITY = this.itemToEdit.FIELD_CAPACITY*100;
      this.form.WILT_POINT = this.itemToEdit.WILT_POINT*100;
      this.form.DENSITY = this.itemToEdit.DENSITY;
    }
  },
  methods: {
    makeAlert(ret) {
      if (ret) {
        alert(ret.log, ret.alert)
      } else {
        alert('Falha ao salvar dados', 'e')
      };
    },
    async submit(data) {
      // soilService[this.formType]
      await soilUseCase()
        [this.formType].execute(data)
        .then(async (resp) => {
          // resp[0] == [] => erro na inserção
          if (!resp[0]) {
            this.makeAlert({
              alert: "e",
              log: "Erro ao tentar inserir dados do solo",
            });
          } else {
            const {
              idSoil,
              formType
            } = this;

            await this.generateManagementRefact({idSoil});

            this.makeAlert({
              alert: "s",
              log: "Cadastro de solo realizado com sucesso",
            });

            await this.updateSoilEditorRefact({
              name: data.NAME,
              fkEditor: data.FK_EDITOR,
              idSoil,
              formType
            });

          }
        })
        .catch((err) => {
          console.error("[SUBMIT SOIL] - ", err);
          this.makeAlert({
            alert: "e",
            log: err,
          });
        });

      this.$emit('get-data-again');
      this.$emit('close-form');
    },
    notEmpty(value) {
      return validate.notEmpty(value);
    },
    resetForm() {
      this.form = {
        NAME:'',
        TRANSMISSIVITY:'',
        FIELD_CAPACITY:'',
        WILT_POINT:'',
        DENSITY:'',
        FK_EDITOR:null
      };
    },
    checkForm() {
      this.errors = [];

      for (let key of Object.keys(this.form)) {
        if (this.form[key] == "") this.form[key] = null;
      }

      const isFieldCapacityBiggerOrEqualThanWiltPoint= Number(this.form.FIELD_CAPACITY)>=Number(this.form.WILT_POINT)
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.transmissibilityState.isValid,
        this.densityInputState.isValid,
        this.fieldCapacityInputState.isValid,
        this.wiltPointInputState.isValid,
        isFieldCapacityBiggerOrEqualThanWiltPoint
      ];

      let erros = [
        "Nome é obrigatório.",
        `O nome escolhido já está em uso.`,
        `Transmissividade do solo é obrigatório `,
        `Densidade aparente ${this.densityInputState.message}`,
        `Capacidade de campo é obrigatório ${this.fieldCapacityInputState.message}`,
        `Ponto de murcha permanente é obrigatório e ${this.wiltPointInputState.message}`,
        "Capacidade de campo não pode ser inferior ao Ponto de Murcha Permanente",
      ];

      states.map((e, i) => {
          if (!e) this.errors.push(erros[i]);
      });

      if (this.errors.length) this.$refs.formError.show();
      else{
        this.form.FK_EDITOR = Number(cookies.get('ID'))
        this.submit({...this.form,FIELD_CAPACITY:this.form.FIELD_CAPACITY/100,WILT_POINT:this.form.WILT_POINT/100})
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0;
    margin-right: 0;
  }
  #form, #details {
    padding-top: 1em;
    /* padding-top: 80px; */
}
}
</style>
